import HelperManager from './plugin';

const helpers = new HelperManager({});

export default helpers;
